import script from "./Link.vue?vue&type=script&setup=true&lang=ts"
export * from "./Link.vue?vue&type=script&setup=true&lang=ts"

import "./Link.vue?vue&type=style&index=0&id=a702c522&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a702c522"]])

export default __exports__